import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import ChildYouthDevelopmentDetails from '../../subdepartmentdetails/ChildYouthDevelopment'


function ChildYouthDevelopment() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Child and Youth Development Programs || Family and Children Services";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Family Community Services"
            title="Child Youth Development"
            subtitledown="Department of Family & Children Services"
           />
            <ChildYouthDevelopmentDetails/>
        </div>
    </>
  )
}

export default ChildYouthDevelopment